<footer class="premium-footer">
  <div class="footer-container">
    <div class="footer-info">
      <h2 class="footer-logo">Weddingly Matrimony</h2>
      <p class="footer-description">
        Designed for lifelong traditions. Helping you bridge the gap between rich cultural heritage and the modern
        search for love.
      </p>
      <div class="footer-socials">
        <a href="#!" aria-label="Facebook"><i class="fab fa-facebook-f"></i></a>
        <a href="#!" aria-label="Twitter"><i class="fab fa-twitter"></i></a>
        <a href="#!" aria-label="WhatsApp"><i class="fab fa-whatsapp"></i></a>
        <a href="#!" aria-label="Instagram"><i class="fab fa-instagram"></i></a>
      </div>
    </div>

    <div class="footer-links-grid">
      <div class="footer-col">
        <h3>Contact Info</h3>
        <p>No 4, 2nd Floor, Kamaraj Colony, Chitlappakkam, Chennai 600064</p>
        <p>Phone: <a href="tel:+919444030066">+91 9840358348</a></p>
        <p>Email: <a href="mailto:help@weddinglymatrimony.com">help@weddinglymatrimony.com</a></p>
      </div>

      <div class="footer-col">
        <h3>Company</h3>
        <a routerLink="/">Home</a>
        <a routerLink="/profiles">Discover</a>
        <a routerLink="/plans">Pricing Plans</a>
      </div>

      <div class="footer-col">
        <h3>Support & Legal</h3>
        <a routerLink="/contact">Contact Support</a>
        <a routerLink="/faq">FAQ</a>
        <a routerLink="/terms">Terms of Service</a>
        <a routerLink="/privacy">Privacy Policy</a>
      </div>
    </div>
  </div>

  <div class="footer-bottom">
    <p>© 2026 Weddingly Matrimony. All rights reserved. Trusted by thousands of families.</p>
  </div>
</footer>